// ** MUI Imports
import { Theme } from '@mui/material';


// Mid-grey at partial opacity reads on both light and dark surfaces, so the
// hub's own dark mode doesn't need a second set.
const SCROLLBAR_THUMB = 'rgba(128, 128, 128, 0.4)';
const SCROLLBAR_THUMB_HOVER = 'rgba(128, 128, 128, 0.65)';

const GlobalStyles = (theme: Theme) => {
  return {
    body: {
      margin: 0,
    },
    // Thin, rounded scrollbars instead of the OS defaults. WebKit/Blink get the
    // pseudo-elements (the thumb inset comes from a transparent border). The
    // standard properties are for Firefox only: Chrome gives them precedence
    // over the pseudo-elements, which would drop the rounded thumb.
    '*::-webkit-scrollbar': {
      width: 10,
      height: 10,
    },
    '*::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: SCROLLBAR_THUMB,
      borderRadius: 999,
      border: '2px solid transparent',
      backgroundClip: 'padding-box',
    },
    '*::-webkit-scrollbar-thumb:hover': {
      backgroundColor: SCROLLBAR_THUMB_HOVER,
    },
    '*::-webkit-scrollbar-corner': {
      background: 'transparent',
    },
    '@supports not selector(::-webkit-scrollbar)': {
      '*': {
        scrollbarWidth: 'thin',
        scrollbarColor: `${SCROLLBAR_THUMB} transparent`,
      },
    },
    code: {
      fontFamily: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
    },
  };
};

export default GlobalStyles;
